import {EstatusProcesoEnum} from '@enumeraciones/Enumeraciones.enum';

export class ErrorSIConvert
{
  public Fila : string = "";

  public Dato : string = "";

  public Descripcion : string = "";

  constructor(init?:Partial<ErrorSIConvert>)
  {
    Object.assign(this, init);
  }
}

export class ImpotacionAnalisis
{
  public Registros : number = 0;

  public Correctos : number = 0;

  public Incorrectos : number = 0;

  public Omitidos : number = 0;

  public Importados : number = 0;

  public Nuevos : number = 0;

  public Repetidos : number = 0;

  public Errores :Array<ErrorSIConvert> = [];
  
  public Advertencias :Array<ErrorSIConvert> = [];

  public Finalizado : boolean = false;

  public Renglon : number = 0;

  constructor(init?:Partial<ImpotacionAnalisis>)
  {
    Object.assign(this, init);
  }
}

export class ImportarProceso
{
  public Titulo : string  = "";

  public Estatus : EstatusProcesoEnum = EstatusProcesoEnum.Pendiente;

  constructor(init?:Partial<ImportarProceso>)
  {
    Object.assign(this, init);
  }
}
